module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_sponsor", [["div",{"class":"sponsor-page clearfix pad-t"}],["section",{"id":"newsletter-container"}],["section",{"id":"#liveshow-container","class":"next-liveshow bg-color-2 text-color-1","itemscope":"","itemtype":"http://schema.org/Event"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/sponsor.tpl
// module id = 1252
// module chunks = 4